import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Card, { CardContent, CardMedia } from 'material-ui/Card';
import IconButton from 'material-ui/IconButton';
import Typography from 'material-ui/Typography';
import Paper from 'material-ui/Paper';
import Grid from 'material-ui/Grid';
import Drawer from 'material-ui/Drawer';
import Button from 'material-ui/Button';
import List from 'material-ui/List';
import Divider from 'material-ui/Divider';

// Components
import Username from './components/Username';
import Description from './components/Description';
import Priority from './components/Priority';
import Age from './components/Age';
import Oar from './components/Oar';
import City from './components/City';
import ProfileImage from './components/ProfileImage';
import FullProfileButton from './components/FullProfileButton';

class Item extends Component {
  render(){
    const { classes, theme, location, data } = this.props;
    return(
      <div>
        <Card className={classes.masterCard}>
          <div className={classes.card}>
            <ProfileImage data={data}/>
            <div className={classes.details}>
              <CardContent className={classes.content} >
                <Username data={data}/>
                <Description data={data}/>
                <div className={classes.demo3}></div>
                <Grid item xs={12}>
                  <Grid container className={classes.demo} justify="left" spacing={6}>
                    <Grid>
                      <Age data={data}/>
                    </Grid>
                      <div className={classes.demo2}></div>
                    <Grid>
                      <Oar data={data}/>
                    </Grid>
                      <div className={classes.demo2}></div>
                    <Grid>
                      <City data={data}/>
                    </Grid>
                  </Grid>
                </Grid>
                <div className={classes.demo3}></div>
                <Priority data={data}/>
              </CardContent>
            </div>
          </div>
          <FullProfileButton data={data}/>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
        customer_number: state.customer.number,
    };
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps)(Item)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/ActionsDrawer/components/CandidateItem/index.js